/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Pw_Check4Inputs */

const en_funnel_pw_check4 = /** @type {(inputs: Funnel_Pw_Check4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chrome extension reads any text on any website`)
};

const es_funnel_pw_check4 = /** @type {(inputs: Funnel_Pw_Check4Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La extensión de Chrome lee cualquier texto en cualquier web`)
};

/**
* | output |
* | --- |
* | "Chrome extension reads any text on any website" |
*
* @param {Funnel_Pw_Check4Inputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_pw_check4 = /** @type {((inputs?: Funnel_Pw_Check4Inputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Pw_Check4Inputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_pw_check4(inputs)
	return en_funnel_pw_check4(inputs)
});